import React from 'react';
import MuiDialogActions from '@mui/material/DialogActions';
import Dialog from 'components/Dialog';
import {Theme} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from 'components/Button';
import {useTranslation} from 'react-i18next';

const DialogActions = withStyles((theme: Theme) => ({
   root: {
      margin: 0,
      padding: theme.spacing(1),
   },
}))(MuiDialogActions);

export enum CancelableConfirmationDialogResult {
   OK,
   NO,
   CANCEL,
}

export type CancelableConfirmationData = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   confirmLabel?: string;
   noLabel?: string;
   cancelLabel?: string;
};

type Props = {
   data: CancelableConfirmationData;
   onClose: (result?: CancelableConfirmationDialogResult) => void;
};
export const CancelableConfirmationDialog = (props: Props) => {
   const {t} = useTranslation();
   const {
      data: {
         open = true,
         content = t('Proceed?'),
         title = t('Confirmation'),
         confirmLabel = t('Ok'),
         noLabel = t('No'),
         cancelLabel = t('Cancel'),
      } = {},
      onClose,
   } = props;

   return (
      <Dialog header={title} open={open}>
         {content}
         <DialogActions>
            <Button onClick={() => onClose(CancelableConfirmationDialogResult.OK)} color="primary">
               {confirmLabel}
            </Button>
            <Button onClick={() => onClose(CancelableConfirmationDialogResult.NO)} color="primary">
               {noLabel}
            </Button>
            <Button onClick={() => onClose(CancelableConfirmationDialogResult.CANCEL)}>
               {cancelLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
};
